import React from 'react';
import { DynamicModuleLoader } from 'redux-dynamic-modules';
import { getUndoableLogoMakerModule } from './useUndoableLogoMakerState';

export const UndoableLogoMakerModuleLoader: ReactFCWithChildren = ({ children }) => {
  return (
    // Until this is merged! https://github.com/microsoft/redux-dynamic-modules/pull/192
    // @ts-ignore
    <DynamicModuleLoader modules={[getUndoableLogoMakerModule()]}>{children}</DynamicModuleLoader>
  );
};
